import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../../../components/common';
import { mergeClassNames } from '../../../utils';
const DialogActionButton = ({ text, triggerAction, className, color, disabled }) => {
    const btnClass = mergeClassNames('mt-3 mx-1 inline-flex flex-1 justify-center rounded-md shadow-sm px-4 py-2 text-base font-medium focus:outline-none sm:mt-0 sm:w-auto sm:text-sm', 'disabled:opacity-25 disabled:text-gray-300 disabled:cursor-default', className);
    return (_jsx(Button, { color: color, className: btnClass, onClick: triggerAction, disabled: disabled, children: text }));
};
export default DialogActionButton;
